"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var api_1 = require("../../utils/api");
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
exports.authError = reselect_1.createSelector(moduleState, function (state) { return state.authError; });
exports.accessToken = reselect_1.createSelector(moduleState, function (state) { return state.accessToken; });
exports.playerState = reselect_1.createSelector(api_1.createApiDataSelector(moduleState, 'playerState'), function (state) { return state.player; });
exports.profile = api_1.createApiDataSelector(moduleState, 'profile');
var albumsState = reselect_1.createSelector(moduleState, function (state) { return state.albumsById; });
exports.getAlbum = reselect_1.createSelector(albumsState, function (state) { return function (albumId) {
    return albumId && state.data[albumId];
}; });
exports.isAlbumLoading = reselect_1.createSelector(albumsState, function (state) { return state.isLoading; });
var albumsSavedState = reselect_1.createSelector(moduleState, function (state) { return state.albumsSavedById; });
exports.getIsAlbumSaved = reselect_1.createSelector(albumsSavedState, function (state) { return function (albumId) {
    return albumId && state.data[albumId];
}; });
exports.isAlbumSavedLoading = reselect_1.createSelector(albumsSavedState, function (state) { return state.isLoading; });
//# sourceMappingURL=selectors.js.map